import MaterialConsumptionHelpMdx from "../../help/material-consumption.mdx";

export function MaterialConsumptionHelpPage() {
  return <MaterialConsumptionHelpMdx />;
}
